import { createActions } from 'redux-actions';

export const { setLanguage } = createActions({
  SET_LANGUAGE: language => language
});



// WEBPACK FOOTER //
// ./src/store/language/actions.js